import Rename from './Rename';

export default Rename;
